import { ref } from "vue"

export const bigModeSideBarOpen = ref(true)
